import React from 'react';
import GpyComponent from './GpyComponent'
import {_GPY} from '../../../env.js'

class GpyTeamSelect extends GpyComponent {
  constructor(props) {
      super(props);
      this.state = {
          selectedPlayer : {id:-1},
          disableRcvSelect: this.props.disableRcvSelect!==undefined&&this.props.disableRcvSelect==="true"?true:false,
          filter : this.props.filter===undefined?  function (list) { return true;
          }:this.props.filter,
          sorter: this.props.sorter===undefined? function (list) {
                       list.sort(function(a, b) {
                         if(a._config===undefined||b._config===undefined) return 0;

                         if(a._config.player!==undefined && b._config.player!==undefined) {
                           if(a._config.player && !b._config.player)return 0;
                           if(!a._config.player && b._config.player)return 1;
                         }
                         if(a._config.substitue!==undefined && b._config.substitue!==undefined) {
                           if(a._config.substitue && !b._config.substitue)return 0;
                           if(!a._config.substitue && b._config.substitue)return 1;
                         }
                         if(a._config.sortIndex!==undefined && b._config.sortIndex!==undefined) {
                           return a._config.sortIndex < b._config.sortIndex ? 0:1;
                         }
                         return 0;
                       });
                       return list;
              }:this.props.sorter,

      };
    }



    preparePlayer(p) {
      if(p.vsUiState === undefined || p.vsUiState === '') {
          p.vsUiState = '{"player":false, "substitue":false, "score":0, "pos": {"x": 10, "y": 10, "xp":5, "yp": 10}, "sortIndex" : 0 }';
      }
      p._config = JSON.parse(p.vsUiState);
    }

    doSelectPlayer(player){
        this.setState({selectedPlayer:player},()=>{
          if((this.props.scoreboard !== undefined && this.props.scoreboard.onSelectPlayer !== undefined)){
            this.props.scoreboard.onSelectPlayer(player);
          }
        });
    }

    refresh() {
      this.forceUpdate();
    }

    selectPlayerById(player){
      this.props.game.players.Player.filter(p => p.vsRole === this.props.vsRole).forEach((p) => {
        if(p.id === player.id) {
          this.setState( {selectedPlayer : player} );
        }
      });
    }

    componentWillMount(){
      if(this.props.scoreboard !== undefined && this.props.scoreboard.registerComponent !== undefined){
         this.props.scoreboard.registerComponent(this.props.stateName,this);
      };
    }

    onChangeValue(obj){

    }

    render () {
      var id_count = 1;
  		return (
        <select value={this.props.getValue()!==undefined?this.props.getValue():-1} onChange={(e)=>{this.props.setValue(e.target.value);this.refresh();}} className="form-control" >
            <option key="-1" value="-1">-</option>
          {this.state.sorter(this.props.game.players.Player.filter(p => p.vsRole === this.props.vsRole).filter(this.state.filter)).map((p) =>
              <option key={p.id} value={p.id}>{p.numOrPos!==undefined&&p.numOrPos!==""?p.numOrPos+" ":""}{p.firstName!==undefined&&p.firstName!==""?p.firstName + " ": ""}{p.lastName}</option>
          )}
        </select>
  		);
    }
}
export default GpyTeamSelect;
